export default "__VITE_ASSET__C_1S4n5Q__"